import React from 'react';
import { AppModal, AppModalBody, AppModalHeader } from 'components/molecules/Modal/AppModal';

function MetaInfoPopup({ isOpen, data = {}, closeModal }) {
  const getFilteredData = (rawData) => {
    if (!rawData || typeof rawData !== 'object') return null;

    const allowedKeys = ['message', 'code', 'name', 'time', 'statuscode', 'statusCode'];
    const filteredData = {};

    allowedKeys.forEach((key) => {
      if (rawData[key] !== undefined) {
        filteredData[key] = rawData[key];
      }
    });

    return Object.keys(filteredData).length > 0 ? filteredData : null;
  };

  const filteredData = getFilteredData(data);

  // Optional: Normalize key labels for readability
  const formatKey = (key) => {
    switch (key.toLowerCase()) {
      case 'statuscode':
        return 'Status Code';
      case 'code':
        return 'Code';
      case 'message':
        return 'Message';
      case 'name':
        return 'Name';
      case 'time':
        return 'Time';
      default:
        return key;
    }
  };

  return (
    <AppModal open={isOpen} closeModal={closeModal} size="md">
      <AppModalHeader>Error Metadata</AppModalHeader>

      <AppModalBody classNames="p-4">
        {filteredData ? (
          <ul>
            {Object.entries(filteredData).map(([key, value]) => (
              <li key={key}>
                <strong>{formatKey(key)}:</strong> {value}
              </li>
            ))}
          </ul>
        ) : (
          <div>No metadata available.</div>
        )}
      </AppModalBody>

      <div className="app-modal-actions">
        <button className="btn btn-secondary" onClick={closeModal}>
          Close
        </button>
      </div>
    </AppModal>
  );
}

export default MetaInfoPopup;
